// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* TODO: Maybe Remove File */\n/* @import 'react-toolbox/variables.css'; */\n/* .dataTable {\n  width: 100%;\n} */\n/* .dataTableContainer {\n  display: flex;\n  flex: 1;\n  width: 100%;\n} */\n.css__withTooltip___3Qxxb th:last-of-type {\n      padding-right: 45px !important;\n  }\n.css__tableContainer___duThp {\n  /* padding-left: 12px;\n  padding-right: 12px; */\n  position: relative;\n  flex: 1;\n}\n.css__paginationBar___2c55S {\n  padding: 0px 12px 0px 12px;\n}\n.css__message___2Ow3q {\n  padding: 0px 12px 0px 12px;\n}", ""]);
// Exports
exports.locals = {
	"withTooltip": "css__withTooltip___3Qxxb",
	"tableContainer": "css__tableContainer___duThp",
	"paginationBar": "css__paginationBar___2c55S",
	"message": "css__message___2Ow3q"
};
module.exports = exports;
